

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import cloneDeep from "lodash/cloneDeep"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "../DataTable.vue"
import FieldPermissions from "../Permissions/FieldPermissions.vue"
import RuleTrigger from "@/components/Config/Rules/RuleTrigger.vue"
import RuleActions from "@/components/Config/Rules/RuleActions.vue"

import { TemplateDetails, Field, Rule, Trigger, RuleAction } from "@/types"
import User from "@/types/user"

import { Operator, operatorLabels } from "@/types/insights/operators"
import { caseColumns, CaseColumn } from "@/types/caseColumns"

import api from "@/services/api"
import integrationApi from "@/services/api_Integrations"

import { IntegrationOutOption } from "@/types/integration"

const setup = namespace("setup")

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"field-permissions": FieldPermissions,
		"skeleton": SkeletonLoader,
		"rule-trigger": RuleTrigger,
		"rule-action": RuleActions
	}
})
export default class RuleSetup extends Vue {
	$refs!: {
		dataTable: DataTable
	}

	@Getter("getMe")
	public me!: User;

	@setup.Getter("getFieldTypes")
	fieldTypes!: [];

	@setup.Getter("getDataSources")
	dataSources!: [];

	@setup.Getter("getDefinitions")
	definitions!: [];

	@setup.Getter("getFieldTypesById")
	fieldTypesById!: { [key: string]: any };

	@setup.Action loadRules!: () => Promise<any[]>;
	@setup.State rules!: Rule[];

	@setup.Mutation setRules!: (rules: Rule[]) => void;

	public loading: boolean = true;
	private loadingRules: boolean = false;

	private triggersValid: boolean = true;
	private actionsValid: boolean = true;

	private integrationOuts: IntegrationOutOption[] = []

	public get columns (): any[] {
		return [
			{
				key: "title",
				label: "Title",
				sortable: true,
				errors: (item: any) => item.title ? null : "Please enter a title"
			},
			{
				key: "triggers",
				label: "Triggers",
				dataType: "list",
				sortable: true,
				hasTemplate: true,
				inModal: (item: any) => false
			},
			{
				key: "actions",
				label: "Actions",
				dataType: "list",
				sortable: true,
				hasTemplate: true,
				inModal: (item: any) => false
			}
		]
	}

	public async mounted () {
		this.loadingRules = true
		await this.loadRules()

		integrationApi.enabledOutputs().then(outputs => {
			this.integrationOuts = outputs
		})

		this.loadingRules = false
		this.loading = false
	}

	async saveRule (rule: Rule) {
		// Clone the original so that changes don't affect data bindings.
		const saveRule = cloneDeep(rule)

		// Ensure that all values are strings.
		saveRule.triggers.forEach(t => {
			t.value = t.value.toString()
		})

		await api.ruleSave(saveRule)
		await this.loadRules()
	}

	async deleteRule (rule: Rule) {
		await api.ruleDelete(rule)
		await this.loadRules()
	}

	createNewItem () {
		return {
			title: "",
			description: "",
			triggers: [],
			actions: []
		}
	}

	private setTriggersValid (valid: boolean): void {
		this.triggersValid = valid
		this.TriggersAndActionsDataValid()
	}

	private setActionsValid (valid: boolean): void {
		this.actionsValid = valid
		this.TriggersAndActionsDataValid()
	}

	private TriggersAndActionsDataValid (): void {
		if (this.triggersValid && this.actionsValid) {
			this.$refs.dataTable.$refs.dataModal.saveButtonDisabled = false
		} else {
			this.$refs.dataTable.$refs.dataModal.saveButtonDisabled = true
		}
	}
}
